///
/// EarthBrowser
///
/// Created by Matt Giger on October 10, 2026
/// Copyright (c) 2026 Geodata Labs
///
/// Insights API: metrics_daily rows for a window plus today's live counts,
/// and the on-demand rollup used to backfill or recompute a day.
///

import { authenticatedApi } from './authenticatedApi'

export interface MetricRow {
  day: string
  metric: string
  dims: Record<string, string>
  value: number
}

export interface InsightsResponse {
  days: number
  rows: MetricRow[]
  live: {
    sessions_today: number
    dau_today: number
    events_today: number
    events_total: number
  }
  lastRollup: { day: string | null; computed_at: string | null }
}

export const insightsApi = authenticatedApi.injectEndpoints({
  endpoints: (builder) => ({
    getInsights: builder.query<InsightsResponse, { days?: number }>({
      query: ({ days = 28 }) => `/api/admin/insights?days=${days}`,
      providesTags: ['Insights'],
    }),
    runInsightsRollup: builder.mutation<{ success: boolean; day: string; written: number }, { day?: string }>({
      query: ({ day }) => ({
        url: `/api/admin/insights/rollup${day ? `?day=${day}` : ''}`,
        method: 'POST',
      }),
      invalidatesTags: ['Insights'],
    }),
  }),
})

export const { useGetInsightsQuery, useRunInsightsRollupMutation } = insightsApi
